import clsx from 'clsx';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { OpenOutline } from 'react-ionicons';

const DiaOrCradlepoint = ({
  carrier,
  price,
  image: Image,
  type,
}: {
  carrier: string;
  price: string;
  image: React.ElementType;
  type: 'dia' | 'cradlepoint';
}) => {
  return (
    <div className="flex flex-wrap gap-6">
      <div className="flex w-full min-w-[300px] flex-1 flex-col gap-4">
        <h1 className={clsx('text-4xl font-bold text-content-base-default')}>
          {carrier}
        </h1>
        <p className="flex flex-col justify-center font-bold">
          <span className="flex h-[38px] gap-1">
            <span className="text-[28px] text-content-base-default">
              {price}
            </span>
            <span className="self-center text-base text-content-base-subdued xl:text-xl">
              /month for 36 months
            </span>
          </span>
          <span className="text-xs">
            {type === 'dia'
              ? '+0 service activation fee'
              : '+ individual or pooled data plan'}
          </span>
        </p>
        {/* <Button type={type} className="hidden self-end xl:flex" /> */}
      </div>
      <div className="flex items-center justify-between gap-8">
        <Image className="w-full" />
      </div>
      {/* <Button type={type} className="mt-3 flex self-end xl:hidden" /> */}
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Button = ({
  type,
  className,
}: {
  type: 'dia' | 'cradlepoint';
  className: string;
}) => {
  return (
    <GraniteButton
      variant="secondary"
      size="medium"
      className={clsx('w-full !cursor-pointer', className)}
    >
      {type === 'dia' ? 'Check availability' : 'View'}
      <OpenOutline width="18px" height="18px" color="inherit" />
    </GraniteButton>
  );
};

export default DiaOrCradlepoint;
